
import { Component, Prop } from 'vue-property-decorator'
import Freemium, { Referrer } from '~/components/common/freemium/Freemium'
import { needToPreopenUnlockProPopup } from '~/middleware/retain-referer'
import { FREEMIUM_CREDIBILITY as FREEMIUM_CREDIBILITY_FLAG } from '~/plugins/feature-flags/flags'
import { getFreemiumCredibilityMixpanelValueNames } from '~/lib/utils/utils'

@Component
export default class ApplyPro extends Freemium {
  @Prop({ type: Boolean, default: false }) showIfPro!: boolean
  @Prop({ type: Boolean, default: false }) preopenPopup!: boolean
  @Prop({ type: String, default: '' }) referrer: Referrer
  @Prop({ type: String, default: '' }) eventName!: string
  @Prop({ type: Boolean, default: false }) customOpenedFrom!: boolean

  get isMob() {
    return this.$accessor.screen.resolution < 768
  }

  get isPro() {
    return !!this.$auth.user.membership && !this.$auth.user.membership?.freemium && !this.$auth.user.membership?.isMaintenanceModeHasEffect
  }

  get isMaintenanceMode() {
    return this.$auth.user.membership?.isMaintenanceModeHasEffect
  }

  click() {
    if (this.eventName) {
      let props = {}

      if (this.$route.params.cardId) {
        props = { scholarshipId: Number(this.$route.params.cardId) }
      }

      if (this.referrer === 'similarity_view' && !this.$route.params.cardId) {
        props = {
          [this.$mixpanel.props.OPENED_FROM]: 'Similarity sent screen'
        }
      }

      if (this.referrer === 'credibility_banner') {
        props = {
          [this.$mixpanel.props.OPENED_FROM]: 'Credibility banner',
          [this.$mixpanel.props.FREEMIUM_CREDIBILITY]: getFreemiumCredibilityMixpanelValueNames(window.$nuxt.$featureFlags?.getVariant(FREEMIUM_CREDIBILITY_FLAG)?.name)
        }
      }
      this.$mixpanel.track(
        this.eventName, this.$mixpanel.fillProps(this.eventName, props)
      )
    }

    this.openModal({
      referrer: this.referrer
    })
  }

  mounted() {
    if (this.preopenPopup && needToPreopenUnlockProPopup()) {
      setTimeout(() => {
        this.click() // emulate popup opening
      }, 1000)
    }
  }
}
